import { render, staticRenderFns } from "./NotificationSpendSuccess.vue?vue&type=template&id=4f9cdc24&scoped=true"
import script from "./NotificationSpendSuccess.vue?vue&type=script&lang=js"
export * from "./NotificationSpendSuccess.vue?vue&type=script&lang=js"
import style0 from "./NotificationSpendSuccess.vue?vue&type=style&index=0&id=4f9cdc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9cdc24",
  null
  
)

export default component.exports